import { Currency } from "../../contexts/types";
import {
  Table, Thead, Tr, Th, Tbody, Td,
  Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow, PopoverCloseButton, PopoverBody, Portal,
  TableContainer,
  Button,
  PlacementWithLogical,
} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import '../common.css';

/**
 * 為替レートの表示形式を整形
 * 小数点以下2桁未満は0埋め、2桁以上はそのまま表示
 */
const formatExchangeRate = (rate: number | undefined): string => {
  if (rate === undefined || rate === null) return '';

  const str = String(rate);
  const decimalIndex = str.indexOf('.');

  // 小数点がない場合は2桁で0埋め
  if (decimalIndex === -1) {
    return rate.toFixed(2);
  }

  // 小数点以下の桁数を取得
  const decimalPlaces = str.length - decimalIndex - 1;

  // 2桁未満の場合は2桁に0埋め
  if (decimalPlaces < 2) {
    return rate.toFixed(2);
  }

  // 2桁以上の場合はそのまま表示
  return str;
};

interface Props {
  currencyData: Currency[];
  headerText?: string;
  placement?: PlacementWithLogical;
  isLoading?: boolean;
  buttonSize?: string;
  fontSize?: string;
}

const CurrencyList: React.FC<Props> = ({ currencyData, headerText = '', placement = 'auto', isLoading = false, buttonSize = 'sm', fontSize }) => {
  const { t } = useTranslation();
  const sortedData = currencyData ? [...currencyData].sort((a, b) => (a.currencyId ?? '').localeCompare(b.currencyId ?? '')) : [];

  return (
    <Popover placement={placement}>
      <PopoverTrigger>
        <Button size={buttonSize} fontSize={fontSize} colorScheme="blue" whiteSpace="nowrap" isDisabled={isLoading || !currencyData || currencyData.length === 0}>
          {t('features.InvestmentScreening.CurrencyList.rateDisplay')}
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent justifyContent="center" alignItems="center" width="fit-content" height="500px" bgColor="#fffff0">
          <PopoverArrow />
          <PopoverHeader fontWeight="bold">
            {headerText}
          </PopoverHeader>
          <PopoverCloseButton />
          <PopoverBody>
            <TableContainer maxHeight={430} overflowY="auto">
              <Table className="mm-ceas-table">
                <Thead position="sticky" top={0} zIndex="10" bgColor="#fffff0">
                  <Tr>
                    <Th textAlign="center" fontWeight="bold">
                      {t('features.InvestmentScreening.CurrencyList.currencyName')}
                    </Th>
                    <Th textAlign="center" fontWeight="bold">
                      {t('features.InvestmentScreening.CurrencyList.exchangeRate')}
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {sortedData.map((c, idx) => (
                    <Tr key={idx}>
                      <Td>{c.currencyName}</Td>
                      <Td textAlign="right">{formatExchangeRate(c.exchangeRate)}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  )
}
export default CurrencyList;
